import React from 'react';
import { styled } from '@mui/material/styles';

const Label = styled('span')(({ theme }) => ({
  fontFamily: 'monospace',
}));

const Preview = styled('span')(({ theme }) => ({
  display: 'inline-block',
  width: theme.spacing(2),
  height: theme.spacing(2),
  border: '1px solid #000',
  borderRadius: '50%',
  margin: theme.spacing(0, 0.5),
}));

const InlineColorPreview = ({ color }) => (
  <span>
    <Label>{color}</Label>
    <Preview style={{ backgroundColor: color}}></Preview>
  </span>
);

export default InlineColorPreview;